<template>
  <v-container>
    <v-row>
      <v-col
        cols="2"
        class="text-center"
      >
        <v-btn
          icon
          x-large
          exact
          to="profile"
        >
          <v-icon>mdi-chevron-left-circle</v-icon>
        </v-btn>
      </v-col>
      <v-col
        cols="10"
      >
        <div class="text-left">
          <h1 class="font-weight-light">Password</h1>
        </div>
      </v-col>
    </v-row>

    <v-card
      class="mx-auto"
      max-width="840"
    >
      
      <v-card-text>Choose a strong password and don't reuse it for other systems.</v-card-text>
      <v-card-text>
        <v-alert
          v-if="hasErrors()"
          color="warning">
          <ul>
            <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
          </ul>
        </v-alert>
        <v-form>
          <v-text-field
            v-model="Password"
            :type="showPassword ? 'text' : 'password'"
            name="Password"
            label="New password"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" 
            @click:append="showPassword = !showPassword"
          />
          <v-text-field
            v-model="PasswordConfirm"
            :type="showConfirmPassword ? 'text' : 'password'"
            name="PasswordConfirm"
            label="Confirm new password"
            :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'" 
            @click:append="showConfirmPassword = !showConfirmPassword"
          />
        </v-form>

        <PasswordValidator v-on:passwordValidation="receiveValidation($event)" :Password="Password" :PasswordConfirm="PasswordConfirm" />

      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          :disabled="!passwordValid"
          @click.prevent="changePassword()"
          rounded
          :loading="loading"
          color="info"
        >
          Change password
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import PasswordValidator from "@/components/PasswordValidator.vue";
export default {
  name: "PasswordUpdate",
  computed: {
    user() {
      return this.$store.state.user.user
    }
  },
  components: {
    PasswordValidator
  },
  data() {
    return {
      drawer: null,
      loading: false,
      showPassword: false,
      showConfirmPassword: false,
      passwordValid: false,
      errors: [],
      Password: '',
      PasswordConfirm: ''
    }
  },
  methods: {
    receiveValidation(pswValidation){
      if (pswValidation.valid){
        this.passwordValid = true
      } else {
        this.passwordValid = false
      }
    },
    changePassword() {
      this.loading = true

      this.$axios.post('users/psw_update', { Password: this.Password, PasswordConfirm: this.PasswordConfirm })
        .then(() => {
          this.loading = false
          this.errors = []
          this.$store.dispatch("addNotification", {
            type: 'success',
            message: 'Horay, Password changed successfully.'
          });
          this.$router.push({ name: 'profile' })
        })
        .catch((error) => {
          if (!error.response) {
            this.errors = ['Network Error']
          } else if (error.response.status) {
            this.errors = error.response.data.errors
          } else {
            this.errors = ['Unknown Error']
          }
        })
        .then(()=>{
          this.loading = false
        })
    },
    hasErrors() {
      return this.errors.length > 0
    },
  }
}
</script>